import { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import {
  deleteProducerCodes,
  exportProducerCodes,
  searchSubProducerCodeCriteria,
} from "../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil";
import { PERMISSIONS } from "../../PermissionsConstants";
import { useProducerCodeList } from "./hooks/useProducerCodeList";
import ProducerCodeExpandedRow from "./ProducerCodeExpandedRow";
import ButtonForModal from "../../../components/ButtonForModal";
import ConfirmBoxDelete from "../../../components/ConfirmBoxDelete";
import { toast } from "../../../components/toastNotification";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import EditProducerCodeModal from "./EditProducerCodeModal";
import { PencilSquareIcon, QrCodeIcon } from "@heroicons/react/24/solid";
import Modal from "../../../components/Modal";
import {
  isEditStateProducer,
  rowForEditProducer,
  prodEditState,
  selectedRowsProdCode,
  prodCodeList,
  fromRecentActivity,
  prodAddState,
  prodCodeMastercarrierId,
  searchDataProdCode,
  searchedProdCodeTableData,
  carrierNameValue,
} from "./atoms/atoms";
import { useGetProducerCodeListByCarrierId } from "./hooks/useGetProdCodeByCarrierId";
import MaterialTable from "../../../components/tables/MaterialExTable";
import CloseIconButton from "../../../components/CloseIconButton";
import { ProdcodeFullView } from "./modals/ViewProducerCodeModal";
import DownloadButton from "../../../components/DownloadButton";
import AddButton from "../../../components/AddButton";
import { FunnelIcon } from "@heroicons/react/24/solid";
import SubTableFilters from "./SubTableFilter";
import useSendEmail from "./hooks/useSendEmail";
import { CarrierAgreementMgmtTabs } from "../carrierAgreementTabs";
import { useHistory } from "react-router-dom";
import { mainSelectedTab } from "../atoms";
import {
  employeeFromProdCodeRow,
  employeeFromProducerCode,
  prodCodeViewRowData,
} from "../Employees/Confie/atoms/atoms";
import { prodCodeShowState } from "./atoms/atoms";
import ProducerCodeModalRow from "./ProducerCodeModalRow";
import ReactTooltip from "react-tooltip";

const ProducerCodeFullPageGrpTbl = ({
  rowData,
  //setViewProdCodes,
  tableloading,
}) => {
  const [viewProdCodes, setViewProdCodes] = useRecoilState(prodCodeShowState);
  const args = rowData;
  const masterCarrierId = rowData?.masterCarrierId
    ? rowData.masterCarrierId
    : rowData?.masterCarrierID;
  const { data: producerCodeData, isLoading: useProdListLoading } =
    useProducerCodeList(args);
  const { data: allProducerCodeListByCarrier } =
    useGetProducerCodeListByCarrierId(masterCarrierId);
  const [fromRecent] = useRecoilState(fromRecentActivity);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsProdCode);
  const [addState, setAddState] = useRecoilState(prodAddState);
  const [masterCarrierIdValue, setMasterCarrierId] = useRecoilState(
    prodCodeMastercarrierId
  );
  const [selectedCarrierName, setSelectedCarrierName] =
    useRecoilState(carrierNameValue);
  const [selectedRow, setSelectedRow] = useState([]);
  const setRowForEdit = useSetRecoilState(rowForEditProducer);
  const setProdCodeList = useSetRecoilState(prodCodeList);
  const [prodEdit, setProdEdit] = useRecoilState(prodEditState);
  const [prodCodeData, setProdCodeData] = useState([]);
  const [value, setValue] = useState(false);
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_edit;
  const addPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_add;
  const viewPermissionEmp =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;

  const userPermissions = useRecoilValue(permissionsSelector);
  const queryClient = useQueryClient();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalCDRC, setOpenModalCDRC] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useRecoilState(isEditStateProducer);
  const [prodCodeDataId, setProdCodeDataById] = useState([]);
  const [prodCodeDataCarrierId, setProdCodeDataByCarrierId] = useState([]);
  const [selectedStatus, setSetStatus] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [status, setSelectedStatus] = useState("");
  const [rowsCount, setRowsCount] = useState(0);
  const user = useRecoilValue(accountAtom);
  const [viewProdCode, setViewProdCode] = useRecoilState(
    employeeFromProdCodeRow
  );
  const [rowViewData, setRowViewData] = useRecoilState(prodCodeViewRowData);
  const [isDownloading, setIsDownloading] = useState(false);
  const [filter, setFilter] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);
  const [resetStatus, setResetStatus] = useState(false);
  const [searchInputsData, setSearchInputsData] =
    useRecoilState(searchDataProdCode);
  const [filteredProducerCodeData, setFilteredproducerCodeData] = useState([]);
  const [searchProducerCodeInputsData, setsearchProducerCodeInputsData] =
    useRecoilState(searchedProdCodeTableData);
  const [exportInputsData] = useState([]);
  const [clearFilter, setClearFilter] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const { mutateAsync: sendProdCodeEmail, isSuccess: emailSuccess } =
    useSendEmail();
  const history = useHistory();
  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const [viewFromProduceCode, setViewFromProduceCode] = useRecoilState(
    employeeFromProducerCode
  );

  useEffect(() => {
    setSelectedRows([]);
    setSetStatus([]);
    setSelectedOption([]);
  }, []);
  const handleEditButton = (rowData) => {
    setProdEdit(true);
    const ProducerCodeDataPerRow = {
      carrierProducerCodeId: rowData.carrierProducerCodeId,
      carrierName: rowData.carrierName,
      masterCarrierID: rowData.masterCarrierID,
      brand: rowData.brand,
      // stateID: rowData.stateID,
      producerCodes: rowData.producerCodes,
      producerSubCodes: rowData.producerSubCodes,
      isActive: rowData.isActive === "Active" ? 1 : 0,
      address: rowData.address,
      city: rowData.city,
      program: rowData.program,
      lobId: rowData.lobId,
      mga: rowData.mga,
      storeNumber: rowData.storeNumber,
      officeCode: rowData.officeCode,
      isMA: rowData.isMA,
      mAproducerCodes: rowData.mAproducerCodes,
      officeName: rowData.officeName,
      distributionChannelName: rowData.distributionChannelName,
      distributionChannelId: rowData.distributionChannelId,
      associatedTo: rowData.associatedTo,
      producer: rowData.producer,
      producerName: rowData.producerName,
      isFranchise: rowData.isFranchise,
      producerCodeTypeName: rowData.producerCodeTypeName,
      masterCode: rowData.masterCode,
      masterCodeStatus: rowData.masterCodeStatus,
      codeLevel: rowData.codeLevel,
      issuedTo: rowData.issuedTo,
      issuedToList: rowData.issuedToList,
      producerCodeTypeId: rowData.producerCodeTypeId,
      rollUpId: rowData.rollUpId,
      rollUpCodeStatus: rowData.rollUpCodeStatus,
      crossSaleList: rowData.crossSaleList,
      crossSale: rowData.crossSale,
      mappedToCdrc: rowData.mappedToCdrc,
      mappedToKeeper: rowData.mappedToKeeper,
      lastName: rowData.lastName,
      firstName: rowData.firstName,
      princetonAgentCode: rowData.princetonAgentCode,
      masterAgentPrincetonId: rowData.masterAgentPrincetonId,
    };

    setRowForEdit(ProducerCodeDataPerRow);
    setProdCodeList(allProducerCodeListByCarrier);
  };

  const oldValues = {
    Carrier: [],
    State: [],
    Offices: [],
    ProducerCode: "",
    MAProducerCode: "",
    AcquisitionName: "",
  };

  const [oldFilteredValue] = useState(oldValues);
  const handleMultiStateSelect = (s) => {
    setSelectedStates(s);
  };
  const searchMutation = useMutation(
    (searchInputsData) =>
      searchSubProducerCodeCriteria({
        ...searchInputsData,
        carrierProducerCodes: args,
      }),

    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFilteredproducerCodeData(
          res.map((responseData) => {
            return {
              ...responseData,
            };
          })
        );

        //setIsFilterMainTable(true);
      },
      onError: (error) => {},
    }
  );

  const searchProducerCodeCriteriaEntry = () => {
    localStorage.removeItem("NotifFilter");
    localStorage.removeItem("ModuleFilter");

    if (!resetStatus) {
      exportInputsData.carrierName = searchInputsData.CarrierName;
      exportInputsData.officeName = searchInputsData.OfficeName;
      exportInputsData.producerCode = searchInputsData.ProducerCode;
      exportInputsData.states = searchInputsData.State;
      if (user.isFranchise && user.isNonFranchise) {
        if (!searchInputsData.IsConfie && !searchInputsData.IsFranchise) {
          const searchData = searchInputsData;
          setSearchInputsData({
            ...searchData,
            IsConfie: true,
            IsFranchise: true,
          });
        }
      } else if (user.isFranchise && !user.isNonFranchise) {
        const searchData = searchInputsData;
        setSearchInputsData({
          ...searchData,
          IsFranchise: true,
        });
      } else {
        const searchData = searchInputsData;
        setSearchInputsData({
          ...searchData,
          IsConfie: true,
        });
      }
      if (
        searchInputsData.CarrierName.length === 0 &&
        searchInputsData.OfficeName.length === 0 &&
        searchInputsData.State.length === 0 &&
        searchInputsData.ProducerCode === "" &&
        searchInputsData.MAProducerCode === "" &&
        searchInputsData.AcquisitionName === "" &&
        (user.isFranchise && user.isNonFranchise ? (
          !searchInputsData.IsConfie && !searchInputsData.IsFranchise
        ) : (
          <></>
        ))
      ) {
        toast.fire("Error", "Search fields must be filled!", "error");
      } else {
        setFilterStatus(true);
        searchMutation.mutate(searchInputsData);
      }
    } else {
      //For Reset
      setSearchInputsData([]);
      setsearchProducerCodeInputsData([]);
      // setIsFilterMainTable(false);
    }
  };

  const handleExportButton = () => {
    try {
      var myCurrentDate = new Date();
      var date =
        myCurrentDate.getFullYear() +
        "-" +
        (myCurrentDate.getMonth() + 1) +
        "-" +
        myCurrentDate.getDate() +
        " " +
        myCurrentDate.getHours() +
        ":" +
        myCurrentDate.getMinutes() +
        ":" +
        myCurrentDate.getSeconds();
      if (args) {
        exportProducerCodes([args], user.isFranchise, user.isNonFranchise).then(
          (content) => {
            var url = window.URL.createObjectURL(content.data);
            let tempLink = document.createElement("a");
            tempLink.href = url;

            tempLink.setAttribute(
              "download",
              "ProducerCodes " + date + ".xlsx"
            );
            tempLink.click();
            // store.addNotification(
            setIsDownloading(false);
            toast.fire(
              "Success",
              "Producer codes were exported successfully",
              "success"
            );
            // );
          }
        );
      }
    } catch (error) {
      toast.fire(
        "Failed",
        "Server Error: Cannot export producer codes due to: " + error,
        "error"
      );
    }
  };

  const onClickCProducercode = (rowData) => {
    setViewProdCode(true);
    setRowViewData({ ...rowData });
  };

  const onClickProducername = (moduleName, producer) => {
    const url = "/carrieragreementmgmt/employee";
    history.push({
      pathname: `/carrieragreementmgmt/employee?actionFrom=ProducerName&employeenumber=${producer}`,
    });
    let userTabs = [
      {
        to: "",
      },
    ];
    [...CarrierAgreementMgmtTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    // setViewFromProduceCode(true);
    setSelectedIndex(index);
  };

  useEffect(() => {
    if (producerCodeData) {
      setProdCodeData(
        producerCodeData.map((data) => ({
          ...data,
          isActive: data.isActive ? "Active" : "Inactive",
        }))
      );
    }
  }, [producerCodeData]);

  const materialColumns = [
    {
      // title: "Producer Code",
      field: "producerCodes",
      render: (rowData, rowStatus) => {
        return (
          <div className="cursor-pointer flex flex-col justify-end w-full text-sm">
            <div
              className="blueAndBold underline uppercase"
              onClick={() => onClickCProducercode(rowData)}
            >
              {rowData.producerCodes ? rowData.producerCodes : "unspecified"}
            </div>
            <div className="mainLabeltextColor">Producer Code</div>
          </div>
        );
      },
    },
    // {
    //   // title: "Status",
    //   field: "producerSubCodes",
    //   render: (row) => (
    //     <div className=" flex  flex-col item-center ">
    //       <div className="flex items-center space-x-2">
    //         <div className="mainLabeltextColor mt-1">SubCode: </div>
    //         <div>
    //           {rowData.producerSubCodes ? (
    //             <span className="blueAndBold text-xxs uppercase">
    //               {rowData.producerSubCodes}
    //             </span>
    //           ) : (
    //             <span className="undefineTextColor">unspecified</span>
    //           )}
    //         </div>
    //       </div>

    //   ),
    // },

    {
      // title: "Producer SubCode",
      field: "producerSubCodes",
      render: (rowData) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="font-medium">
              {rowData.producerSubCodes ? (
                <span className=" font-bold-400 uppercase text-xs">
                  {rowData.producerSubCodes}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>

            <div className="mainLabeltextColor">SubCode</div>
          </div>
        );
      },
    },
    {
      //title: "Agency",
      field: "brand",
      render: (row) => {
        return (
          <div className=" flex  flex-col text-sm">
            <div className="font-medium">
              {row.brand ? (
                <span className=" font-bold-400 uppercase text-xs">
                  {row.brand}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">Agency</div>
          </div>
        );
      },
    },
    { field: "officeName", hidden: true },
    { field: "officeCode", hidden: true },
    { field: "address", hidden: true },
    { field: "city", hidden: true },
    { field: "state", hidden: true },
    { field: "zipcode", hidden: true },
    {
      // title: "Associated To",
      field:
        "city" &&
        "officeName" &&
        "officeCode" &&
        "address" &&
        "state" &&
        "zipcode" &&
        "producerName",
      render: (row) =>
        row.associatedTo === "Producer" ? (
          <div className="flex  flex-col">
            <div>
              <ReactTooltip place="right" effect="solid" type="info" />
              {userPermissions.includes(viewPermissionEmp) ? (
                row.producerName !== "" ? (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      onClickProducername("employee", row.producer);
                    }}
                  >
                    <span className=" font-bold-400 uppercase">
                      <span className="blueAndBold underline uppercase">
                        {row.producerName}
                      </span>
                    </span>
                  </div>
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )
              ) : row.producerName !== "" ? (
                <div
                  data-tip={
                    "Contact your System Administrator to secure access to employee module."
                  }
                  className="cursor-pointer"
                >
                  <span>{row.producerName}</span>
                </div>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>

            <div className="mainLabeltextColor">Associated To</div>
          </div>
        ) : row.associatedTo === "Office" ? (
          <div className="flex  flex-col">
            <div>
              <span className=" font-bold-400 uppercase">
                <span className="text-xs">
                  {row.officeCode} - {row.officeName}
                </span>
              </span>
            </div>
            <div className="text-xs">
              {" "}
              {row.address}
              {", "} {row.city}
              {", "} {row.state}
              {", "} {row.zipCode}
            </div>
            <div className="mainLabeltextColor">Associated To</div>
          </div>
        ) : (
          <div className="flex  flex-col">
            <div className="undefineTextColor">unspecified</div>
            <div className="mainLabeltextColor">Not Associated</div>
          </div>
        ),
    },
    { field: "program", hidden: true },
    { field: "mga", hidden: true },
    { field: "distributionChannelName", hidden: true },
    { field: "codeLevel", hidden: true },
    {
      // title: "Status",
      field: "program" || "mga" || "distributionChannelName" || "codeLevel",
      render: (row) => (
        <div className=" flex  flex-col item-center ">
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">Program: </div>
            <div>
              {row.program ? (
                <span className=" font-bold-400 text-xxs uppercase">
                  {row.program}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">MGA: </div>
            <div>
              {row.mga ? (
                <span className=" font-bold-400 text-xxs uppercase">
                  {row.mga}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">Dist. Channel: </div>
            <div className="font-medium">
              {row.distributionChannelName ? (
                <span className=" font-bold-400 text-xxs uppercase">
                  {row.distributionChannelName}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">Code Level: </div>
            <div className="font-medium">
              {row.codeLevel ? (
                <span className="font-bold-400 text-xxs uppercase">
                  {row.codeLevel}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
        </div>
      ),
      width: "15%",
    },

    {
      // title: "Status",
      field: "isActive",
      render: (row) => (
        <div className=" flex flex-col item-center">
          <div className="flex items-center space-x-2">
            <label
              style={{ background: row.isActive !== "Inactive" && "#0C77BD" }}
              className="react-switch-label text-center"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap indent-1.5  ">
                {row.isActive === "Inactive" ? "No" : "Yes"}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">is Active</div>
          </div>
          {/* <div className="flex items-center space-x-2">
            <label
              style={{ background: row.isFranchise && "#0C77BD" }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap indent-1.5  ">
                {row.isFranchise ? "Yes" : "No"}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">is Franchise</div>
          </div> */}

          <div className="flex items-center space-x-2">
            <label
              style={{ background: row.mappedToCdrc && "#0C77BD" }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap indent-1.5  ">
                {row.mappedToCdrc ? "Yes" : "No"}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">mapped To Cdrc</div>
          </div>

          <div className="flex items-center space-x-2">
            <label
              style={{ background: row.mappedToKeeper && "#0C77BD" }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap indent-1.5  ">
                {row.mappedToKeeper ? "Yes" : "No"}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">mapped To Keeper</div>
          </div>
        </div>
      ),
    },

    {
      // title: "Action/s",
      center: true,
      render: (rowData) => {
        return (
          <div className=" flex justify-center">
            {userPermissions.includes(editPermission) ? (
              <ButtonForModal
                className={
                  (selectedRows.length > 0 ? "opacity-50 cursor-pointer" : "") +
                  " border-quaternary text-white bg-quaternary  "
                }
                isDisabled={selectedRows.length > 0}
                onClick={() => {
                  handleEditButton(rowData);
                }}
              >
                <PencilSquareIcon className="h-4 w-4" />
                Edit
              </ButtonForModal>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
  ];

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to Deactivate ${rowsCount} ${
      rowsCount > 1 ? " Producer Codes" : " Producer Code"
    } ?`}</div>
  );

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
  };

  const handleBulkDelete = () => {
    // carrierProducerCodeId
    const ids = selectedRows.map((row) => row.carrierProducerCodeId);
    deleteProduceCodeMutation.mutate(ids);
  };

  const handleSearchInputs = (fieldName, selectedValue) => {
    setResetStatus(false);
    // setFromRecent(false);
    // setFromRecentId(null);
    if (fieldName !== "Refresh") {
      setSearchInputsData((searchInputsData) => ({
        ...searchInputsData,
        [fieldName]: selectedValue,
      }));
    } else {
      setResetStatus(true);
      // setIsFilterMainTable(false);
      setFilteredproducerCodeData([]);
      setsearchProducerCodeInputsData([]);
    }
  };

  const deleteProduceCodeMutation = useMutation(
    (producerCodeIds) => deleteProducerCodes(producerCodeIds, user?.username),
    {
      onSuccess: (res) => {
        if (res.statusText !== "Bad Request") {
          queryClient.invalidateQueries("ProducerCodeList");
          sendProdCodeEmail(res.data, {
            onSuccess: (res) => {
              if (res) {
                if (res.status === 400) {
                  toast.fire(
                    "Success",
                    "Producer Codes Deactivated Successfully, but failed in sending email",
                    "warning"
                  );
                } else {
                  toast.fire(
                    "Success",
                    `Producer Codes were Deactivated successfully`,
                    "success"
                  );
                }
              }
              setOpenModalDelete(false);
              setOpenModalCDRC(false);
              setSelectedRows([]);
              setSelectedOption([]);
            },
          });
        } else {
          setOpenModalDelete(false);
          setOpenModalCDRC(false);
          setSelectedRows([]);
          setSelectedOption([]);
          toast.fire("", res.data, "warning");
        }
      },
      onError: (error) => {
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          queryClient.invalidateQueries("ProducerCodeList");
          toast.fire(
            "Success",
            "Producer Codes were Deactivated successfully, but " +
              error.response.data.message,
            "warning"
          );
          setOpenModalDelete(false);
          setSelectedRows([]);
          setSelectedOption([]);
        } else {
          toast.fire(
            "Bulk Deactivating of Producer Codes failed",
            "Server Error: Cannot Inactivate ProducerCode",
            "error"
          );
          setOpenModalDelete(false);
          setSelectedRows([]);
          setSelectedOption([]);
        }
      },
    }
  );
  const handleClose = () => {
    setOpenModalEdit(false);
  };

  const closeProducerCodeView = () => {
    setViewProdCode(false);
  };

  return (
    <div className="w-full borderContainer border-quinary border-l-2 ">
      <div className="relative border border-gray-200 z-10">
        <CloseIconButton onClick={() => setViewProdCodes(false)} />

        <div className="flex justify-between tems-center space-x-4 mx-2 ">
          <div className="flex items-center space-x-4">
            <QrCodeIcon className="text-white bg-blue-500 rounded-md h-10 w-10 p-1" />

            <div className="text-xs text-gray-600 font-medium py-4">
              <label>Producer Code</label>
              <div className="flex items-center font-bold-400 blueAndBold">
                {args.carrierName}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4">
                <div>{args.masterCarrierAddress}</div>
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center">
            {userPermissions.includes(addPermission) && (
              <AddButton
                buttonText="Add"
                onClick={() => {
                  setAddState(true);
                  setMasterCarrierId(args?.masterCarrierId);
                  setSelectedCarrierName(args?.carrierName);
                }}
              />
            )}
            <DownloadButton
              buttonValue={isDownloading ? "Downloading" : "Download File"}
              onClick={() => {
                handleExportButton();
                setIsDownloading(true);
                setClearFilter(true);
              }}
              disabled={isDownloading ? true : false}
              className="hover:scale-90 transition duration-500 bg-tranparent mr-2 border-quinary shadow-md hover:bg-quinary text-quinary group relative flex justify-center items-center py-1 px-3 border text-xs font-medium rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary focus:ring-opacity-70 ml-2"
            />
          </div>
        </div>

        <div className="px-4 pb-1 border-secondary border-b-2" />
      </div>
      <div className="p-4">
        <button
          disabled={prodEdit}
          className="disabled:opacity-25 disabled:cursor-not-allowed hover:scale-90 
              focus:bg-primary focus:text-white flex justify-center items-center shadow-md px-3  h-7 text-xs gap-x-2 font-semibold text-primary border 
              hover:bg-primary selected hover:text-white border-primary rounded-md "
          onClick={() => {
            setFilter(!filter);
          }}
        >
          <div>Filter By</div>
          <FunnelIcon className="h-3 w-3" />
        </button>
      </div>
      <div className="flex justify-start">
        {filter && (
          <SubTableFilters
            oldFilteredValue={oldFilteredValue}
            setResetStatus={setResetStatus}
            searchProducerCodeCriteriaEntry={searchProducerCodeCriteriaEntry}
            clearFilter={clearFilter}
            setClearFilter={setClearFilter}
            handleSearchInputs={handleSearchInputs}
            setFilterStatus={setFilterStatus}
            setFilteredproducerCodeData={setFilteredproducerCodeData}
          />
        )}

        <div className="w-full">
          {userPermissions.includes(editPermission) ? (
            <div className="text-secondary px-4 py-2 italic text-xs3 ">
              {!prodEdit ? (
                <div>
                  <p className="self-center font-bold italic inline-block mr-1">
                    Note:{" "}
                  </p>
                  Tick the box to deactivate some data.
                </div>
              ) : (
                <div></div>
              )}
            </div>
          ) : (
            ""
          )}
          <div className="mx-4 rounded-lg box-shadow grid grid-row overflow-x-auto">
            <MaterialTable
              isLoading={
                filteredProducerCodeData?.length > 0
                  ? false
                  : producerCodeData?.length > 0
                  ? false
                  : true
              }
              columns={materialColumns}
              data={
                filteredProducerCodeData?.length > 0
                  ? filteredProducerCodeData
                  : fromRecent
                  ? producerCodeData
                  : !filterStatus
                  ? prodCodeData
                  : []
              }
              paging={prodCodeData?.length > 10}
              pageSize={10}
              search={false}
              toolbar={false}
              selection={true}
              showTitle={false}
              headerStyle={{
                display: "none",
              }}
              selectedRows={selectedRows}
              onSelectionChange={handleSelectedRowsChange}
              setSetStatus={setSetStatus}
              setOpenModal={setOpenModalDelete}
              setCDRCOpenModal={setOpenModalCDRC}
              selectedRow={selectedRow}
              showToolBar={true}
              toolBarComponent={true}
              searchFieldAlignment={"left"}
            />
          </div>
        </div>
      </div>

      {viewProdCode && (
        <ProdcodeFullView
          showFullView={viewProdCode}
          producerCodeId={rowViewData?.producerCodes}
          closeFullView={closeProducerCodeView}
        >
          <ProducerCodeExpandedRow data={rowViewData} />
        </ProdcodeFullView>
      )}
      <ConfirmBoxDelete
        ModalTitle={`${selectedStatus}`}
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={handleBulkDelete}
      />
      {openModalEdit && (
        <Modal
          isOpen={openModalEdit}
          onClose={() => {
            handleClose();
          }}
          hasCloseButton={false}
        >
          <div className="w-full">
            <EditProducerCodeModal
              selectedRows={selectedRows}
              producerCodeData={producerCodeData}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ProducerCodeFullPageGrpTbl;
